import { FieldMapValue } from '@hb/shared'
import { createContext } from 'react'

export const FormLabelsContext = createContext<{
  value?: FieldMapValue
}>({})
